import styled from 'styled-components';

export const AppInitializationLoadingScreen = styled.div`
  height: 100vh;
`;
